<div class="catalog-container" #catalogContainer [ngClass]="{ 'overflow-hidden': isFormOpen() }">
    <div class="carousel-wrapper" [ngClass]="{ 'blur overflow-hidden': isFormOpen() }">

        @if (isAssignMode()) {
                <ng-container  *ngTemplateOutlet="activeAssignmentTemplate()"></ng-container>
        } @else {

          @if(isLoading()) {
              <carousel-skeleton/>
          } @else {

              @if(roomGroups()?.length; as length) {
                <carousel [dataSource]="roomGroups()" class="carousel">
                    <span carousel-label>Room Group ({{length}})</span>
                    <button-group carousel-action>
                        <span
                            stop-click-bubble
                            (click)="openAddForm(addRoomGroup)"
                            button-1
                            role="button">
                                <svg-icon key="add-circle"></svg-icon>
                        </span>
                        <span button-2 role="button" >
                            <svg-icon key="pencil"></svg-icon>
                        </span>
                        <span button-3 role="button" >
                                <svg-icon key="archive"></svg-icon>
                        </span>
                    </button-group>
                </carousel>
              }

  
              @if(rooms()?.length; as length) {
                <carousel [enableHover]="!isAssignMode()" [dataSource]="rooms()" class="carousel-top-center carousel">
                    <span carousel-label>Room ({{length}})</span>
                    @if (canEditRoom()) {
                        <button-group carousel-action #buttonGroup>
                        <span
                            class="align-middle"
                            stop-click-bubble
                            (click)="openAddForm(addRoom)"
                            button-1
                            role="button">
                                <svg-icon key="add-circle"></svg-icon>
                        </span>
                        <span class="align-middle" button-2 role="button" >
                            <svg-icon key="pencil"></svg-icon>
                        </span>
                        <span (click)="buttonGroup.openAssignOptions($event, assignRoomOptionsTemplate)" class="align-middle" button-3 role="button" >
                            <svg-icon key="assign"></svg-icon>
                        </span>
                        <span class="align-middle" button-4 role="button" >
                                <svg-icon key="archive"></svg-icon>
                        </span>
                    </button-group>
                    }
                </carousel>
              }

  
              <!-- <carousel [dataSource]="filteredDepartmentGroups()" class="carousel">
                  <span carousel-label>Department Group ({{filteredDepartmentGroups().length}})</span>
                  <button-group carousel-action>
                      <span
                          stop-click-bubble
                          (click)="openAddForm(addDepartmentGroup)"
                          button-1
                          role="button">
                            <svg-icon key="add-circle"></svg-icon>
                      </span>
                      <span button-2 role="button" >
                          <svg-icon key="pencil"></svg-icon>
                      </span>
                      <span button-3 role="button" >
                            <svg-icon key="archive"></svg-icon>
                      </span>
                  </button-group>
              </carousel>
   -->


              @if (departments()?.length; as length) {
                <carousel [dataSource]="departments()" class="carousel">
                    <span carousel-label>Department ({{length}})</span>
                    @if (canEditDepartment()) {
                        <button-group carousel-action>
                            <span
                                stop-click-bubble
                                (click)="openAddForm(addDepartment)"
                                button-1
                                role="button">
                                    <svg-icon key="add-circle"></svg-icon>
                            </span>
                            <span button-2 role="button" >
                                <svg-icon key="pencil"></svg-icon>
                            </span>
                            <span class="align-middle" (click)="loadAssignmentTemplate(roomToDepartment)" class="align-middle" button-3 role="button" >
                                <svg-icon key="assign"></svg-icon>
                            </span>
                            <span class="align-middle" button-4 role="button" >
                                    <svg-icon key="archive"></svg-icon>
                            </span>
                        </button-group>
                    }
                </carousel>
              }
              
  
  
              @if (projects()?.length; as length) {
                <carousel [dataSource]="projects()" [revealOnHover]="true" class="carousel">
                    <span carousel-label>Project ({{length}}) </span>
                    @if (canAddProject()) {
                    <button-group carousel-action [showDividers]="false">
                        <span
                            stop-click-bubble
                            (click)="openAddForm(addProject)"
                            button-1
                            role="button">
                                <svg-icon key="add-circle"></svg-icon>
                        </span>
                        <!-- <span button-2 role="button" >
                            <svg-icon key="pencil"></svg-icon>
                        </span>
                        <span class="align-middle" (click)="loadAssignmentTemplate(departmentToProject)" class="align-middle" button-3 role="button" >
                            <svg-icon key="assign"></svg-icon>
                        </span>
                        <span class="align-middle" button-4 role="button" >
                                <svg-icon key="archive"></svg-icon>
                        </span> -->
                    </button-group>
                    }
                </carousel>
              }
  
  
              @if (programs()?.length; as length) {
                <carousel [dataSource]="programs()" class="carousel">
                    <span carousel-label>Program ({{length}})</span>
                    @if (canEditProgram()) {
                        <button-group carousel-action>
                            <span
                                stop-click-bubble
                                (click)="openAddForm(addProgram)"
                                button-1
                                role="button">
                                    <svg-icon key="add-circle"></svg-icon>
                            </span>
                            <span button-2 role="button" >
                                    <svg-icon key="pencil"></svg-icon>
                            </span>
                            <span (click)="loadAssignmentTemplate(projectToProgram)" class="align-middle" button-3 role="button" >
                                <svg-icon key="assign"></svg-icon>
                            </span>
                            <span class="align-middle" button-4 role="button" >
                                    <svg-icon key="archive"></svg-icon>
                            </span>
                        </button-group>
                    }

                </carousel>
              }

  
  
              @if (categories()?.length; as length) {
                 <carousel [dataSource]="categories()" class="carousel">
                  <span carousel-label>Category ({{length}})</span>
                  @if (canEditCategory()) {
                  <button-group carousel-action>
                      <span
                          class="align-middle"
                          stop-click-bubble
                          (click)="openAddForm(addCategory)"
                          button-1
                          role="button">
                            <svg-icon key="add-circle"></svg-icon>
                      </span>
                      <span class="align-middle" button-2 role="button" >
                            <svg-icon key="pencil"></svg-icon>
                      </span>
                      <span class="align-middle" (click)="loadAssignmentTemplate(roomContentToCategory)" class="align-middle" button-3 role="button" >
                          <svg-icon key="assign"></svg-icon>
                      </span>
                      <span class="align-middle" button-4 role="button" >
                            <svg-icon key="archive"></svg-icon>
                      </span>
                  </button-group>
                }
              </carousel> 
              }
  
            @if (roomContents()?.length; as length) {
              <carousel [dataSource]="roomContents()" class="carousel">
                  <span carousel-label>Room Content ({{length}})</span>
                  @if (canEditRoomContent()) {
                  <button-group carousel-action>
                      <span
                          stop-click-bubble
                          (click)="openAddForm(addRoomContent)"
                          button-1
                          role="button">
                            <svg-icon key="add-circle"></svg-icon>
                      </span>
                      <span button-2 role="button" >
                           <svg-icon key="pencil"></svg-icon>
                      </span>
                      <span button-3 role="button" >
                            <svg-icon key="archive"></svg-icon>
                      </span>
                  </button-group>
                }
              </carousel> 
            }
  
          } 
        }
          
      </div>
      
  
      @if (activeFormTemplate()) {
          <div class="dialog-form" [@fadeSlideIn]>
              <ng-container  *ngTemplateOutlet="activeFormTemplate()"></ng-container>
          </div>
      }
     
  </div>

<ng-template #addRoomContent>
    <add-room-content-form
        [categories]="[]"
        card-content />
</ng-template>

<ng-template #addCategory>
    <add-category-form card-content />
</ng-template>

<ng-template #addProgram>
    <add-program-form
        [companyId]="companyId()"
        card-content />
</ng-template>

<ng-template #addProject>
    <add-project-form
        card-content
        [programs]="programs()" />
</ng-template>

<ng-template #editProject>
    @if (editingProject(); as editingProject) {
        <edit-project-form
            card-content
            [project]="editingProject"
            [programs]="programs()" />
    }
</ng-template>

<ng-template #addDepartmentGroup>
    <add-department-group card-content />
</ng-template>

<ng-template #addDepartment>
    <add-department-form
        card-content
        [companyId]="companyId()"
        [projects]="projects()"
        [programs]="programs()" />
</ng-template>

<ng-template #addRoomGroup>
    <add-room-group card-content />
</ng-template>

<ng-template #addRoom>
    <add-room-form
        card-content
        [projects]="projects()"
        [programs]="programs()"
        [companyId]="companyId()" />
</ng-template>


<ng-template #assignRoomOptionsTemplate>
    <div class="d-flex flex-column gap-2">
        <rounded-button>
            Assign Room Options
        </rounded-button>

        <rounded-button>
            Assign Room Variations
        </rounded-button>

        <rounded-button (click)="loadAssignmentTemplate(roomContentToRoom)">
            Assign Room Content
        </rounded-button>
    </div>
</ng-template>


<ng-template #assignProgramOptionsTemplate>
    <div class="d-flex flex-column gap-2">
        <rounded-button (click)="loadAssignmentTemplate(projectToProgram)">
            Project
        </rounded-button>

        <rounded-button (click)="loadAssignmentTemplate(departmentToProgram)">
            Department
        </rounded-button>
    </div>
</ng-template>

<ng-template #roomContentToRoom>
    <assign-room-content-to-room
        (onCancelAssignment)="cancelAssignment()"
        [rooms]="rooms()"
        [assignedRoomContents]="roomContents()"
        [roomContents]="roomContents()" />
</ng-template>


<ng-template #roomContentToCategory>
    <assign-room-content-to-category
        (onCancelAssignment)="cancelAssignment()"
        [categories]="categories()"
        [assignedRoomContents]="roomContents()"
        [roomContents]="roomContents()" />
</ng-template>

<ng-template #roomToDepartment>
    <assign-room-to-department
        (onCancelAssignment)="cancelAssignment()"
        [departments]="departments()"
        [assignedRooms]="rooms()"
        [rooms]="rooms()" />
</ng-template>


<ng-template #departmentToProgram>
    <assign-department-to-program
        (onCancelAssignment)="cancelAssignment()"
        [programs]="programs()"
        [assignedDepartments]="departments()"
        [departments]="departments()" />
</ng-template>


<ng-template #projectToProgram>
    <assign-project-to-program
        (onCancelAssignment)="cancelAssignment()"
        [programs]="programs()"
        [assignedProjects]="projects()"
        [projects]="projects()" />
</ng-template>

<ng-template #departmentToProject>
    <assign-department-to-project
        (onCancelAssignment)="cancelAssignment()"
        [projects]="projects()"
        [assignedDepartments]="departments()"
        [departments]="departments()" />
</ng-template>
